function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.5 283.5"
}, props), /*#__PURE__*/React.createElement("g", {
  id: "Window_blinds"
}, /*#__PURE__*/React.createElement("title", null, "VF_window_blinds_rgb"), /*#__PURE__*/React.createElement("path", {
  d: "M0 14.2v255.1h283.5V14.2H0zm255.1 49.6h-99.2V42.5h99.2v21.3zm-127.5 49.6v21.3H28.4v-21.3h99.2zM28.4 99.2V78h99.2v21.2H28.4zm99.2 49.6v21.3H28.4v-21.3h99.2zm0 35.4v21.3H28.4v-21.3h99.2zm28.3 0h99.2v21.3h-99.2v-21.3zm0-14.1v-21.3h99.2v21.3h-99.2zm0-35.5v-21.3h99.2v21.3h-99.2zm0-35.4V78h99.2v21.2h-99.2zm-28.3-56.7v21.2H28.4V42.5h99.2zM28.4 219.7h99.2v21.2H28.4v-21.2zm127.5 21.2v-21.2h99.2v21.2h-99.2z"
}))));